const overrides = {
    field: {
        usageType: {
            partner: {
                MSA: {
                    states: ['IL', 'IN', 'KY', 'OH', 'NJ', 'PA']
                }
            }
        },
        propertyLosses: {
            partner: {
                MSA: {
                    states: ['IL', 'IN', 'KY', 'OH', 'NJ', 'PA', 'UT']
                }
            }
        },
        atFaultAutoLosses: {
            partner: {
                MSA: {
                    states: ['IL', 'PA', 'VA', 'NH']
                }
            }
        },
        autoLosses: {
            partner: {
                MSA: {
                    states: ['IL', 'PA', 'VA', 'NH']
                }
            }
        }
    }
};

export default overrides;
